import styled from 'styled-components';
import { Box, Button, Text, Absolute } from '@rsos/base-components';
import {
  AccordionContentContainer,
  AccordionHeader,
  AccordionTriggerButton,
  AccordionWrapper,
} from '@rsos/components/capstone/base/Accordion/Accordion.styles';
import { Container } from '@rsos/components/capstone/base/Button/Button.styles';

interface BoxWithShowBorder {
  showBorder: boolean;
}

export const TF911Container = styled(Box)`
  transition: max-height 0.6s ease;
  position: relative;
`;

export const HeaderContainer = styled(Box).attrs({
  position: 'relative',
  align: 'center',
  width: '100%',
  backgroundColor: 'background',
  borderRadius: '5px',
  paddingBottom: '8px',
  border: `1px solid`,
  borderColor: 'lightLineDivider',
})``;

export const ActionsBox = styled(Box).attrs({
  position: 'relative',
  horizontal: true,
  align: 'center',
  flex: '0 0 auto',
})``;

interface ActionButtonInterface extends BoxWithShowBorder {
  noMargin: boolean;
}

export const ActionButton = styled(Box).attrs<ActionButtonInterface>(
  ({ noMargin }) => ({
    align: 'center',
    justify: 'center',
    width: '24px',
    height: '24px',
    marginRight: noMargin ? 0 : '5px',
    backgroundColor: 'background',
    borderRadius: '5px',
  }),
)<ActionButtonInterface>`
  ${({ showBorder, theme }) =>
    showBorder && `border: 1px solid ${theme.colors.heavyLineOutline}`};
  transition: background-color 0.3s;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => `${theme.colors.lightLineDivider}`};
  }
`;

// bottom left and bottom right
const TF911_BOTTOM_BORDER_RADIUS = `border-radius: 0 0 5px 5px;`;

// Adds styling to the Accordion components to accommodate design requirements
// in addition to dynamic height of available space in the call pane.
export const AccordionContainer = styled(Box)<BoxWithShowBorder>`
  height: 100%;
  ${AccordionWrapper} {
    height: 100%;
    ${TF911_BOTTOM_BORDER_RADIUS}

    ${AccordionHeader} {
      border-bottom: ${({ showBorder, theme }) =>
        showBorder ? `1px solid ${theme.colors.foreground}` : 'none'};
      ${({ showBorder }) =>
        !showBorder &&
        `${TF911_BOTTOM_BORDER_RADIUS}`} // accordion collapsed vs expanded state
      padding-bottom: 16px;
      padding-left: 0;
      padding-right: 0;
      ${AccordionTriggerButton} {
        border-radius: 0 5px 5px 0;
        margin: 0;
        margin-left: 2px;
        &:hover {
          background-color: ${({ theme }) => `${theme.colors.foreground}`};
        }
      }
    }
    ${AccordionContentContainer} {
      ${TF911_BOTTOM_BORDER_RADIUS}
    }
  }
`;

const BaseTFButton = styled(Button)`
  /* spacing between icon and text */
  ${Container} {
    grid-column-gap: 4px;
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const EndChatContainer = styled(Box)`
  height: 100%;
  padding-bottom: 4px;
  width: 100%;
`;

export const EndChatButton = styled(Button)`
  border-radius: 5px;
`;

export const EndChatButtonNext = styled(BaseTFButton)``;

export const LiveVideoButton = styled(BaseTFButton)``;

export const StartMessagesContainer = styled(Box)`
  ${TF911_BOTTOM_BORDER_RADIUS}
`;

export const StartMessageContainer = styled(Box)`
  &:hover {
    background-color: ${({ theme }) => `${theme.colors.lightLineDivider}`};
  }
`;

export const StartMessage = styled(Text).attrs({})`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 12px;
`;

export const RedCircle = styled(Box)`
  background-color: ${({ theme }) => `${theme.colors.lightDanger}`};
  border-radius: 10px;
  display: inline-flex;
  height: 8px;
  margin-right: 4px;
  width: 8px;
`;

// has overlapping border with TF911Container if there isn't an ongoing/existing chat
export const ChatContainer = styled(Box)<BoxWithShowBorder>`
  border-top: ${({ showBorder, theme }) =>
    showBorder ? `1px solid ${theme.colors.lightLineDivider}` : 'none'};
`;

export const AcceptDeclineContainer = styled(Box)`
  height: 100%;
  padding-bottom: 12px;
  width: 100%;
`;

export const AcceptButton = styled(Button)``;

export const DeclineButton = styled(BaseTFButton)``;

export const AbsoluteAllMessagesContainer = styled(Absolute).attrs({
  top: 0,
  left: 0,
  width: '100%',
})`
  height: 100%;
  border-radius: 5px;
`;
